import dynamic from 'next/dynamic';

// The whole experience is client-only — it drives WebGL and reads window/
// document during render. The App Router kept it off the server via
// 'use client'; in the Pages Router that job falls to `ssr: false`.
export default dynamic(() => import('3_containers/LandingPage/LandingPage'), {
  ssr: false,
});
